<template>
  <div class="pa-4">
    <h1>使用 CSS 实现等距对象</h1>
    <div>
      <span>
        width: {{ width }}%
      </span>
      <v-slider
        v-model="width"
        style="border: 1px solid;border-radius: 0.3rem;"
        class="my-2"
        hint="宽度"
        max="100"
        min="0"
        persistent-hint
        thumb-label
        step="10"
        :tick-labels="ticksLabels"
        tick-size="5"
      >
        <template
          v-slot:thumb-label="{ value }"
        >
          <div style="font-size: xx-large;">
            {{ satisfactionEmojis[Math.min(Math.floor(value / 10), 9)] }}
          </div>
        </template>
      </v-slider>

      <p>flex方案</p>
      <div
        :style="{ width: `${width}%` }"
        class="box box1"
      >
        <div
          v-for="item,key in 4"
          :key="key"
          class="item1"
        >
          item{{ item }}
        </div>
      </div>

      <p>float方案 ????</p>
      <div
        :style="{ width: `${width}%` }"
        class="box2"
      >
        <div class="box2item1">
          item1
        </div>
        <div class="box22">
          <div class="box222">
            <div class="itemmmm">
              item2
            </div>
          </div>
          <div class="box222">
            <div class="itemmmm">
              item3
            </div>
          </div>
          <div class="box222">
            <div class="itemmmm">
              item4
            </div>
          </div>
        </div>
      </div>

      <p>inline-block 方案 ????</p>
      <div
        :style="{ width: `${width}%` }"
        class="box box3"
      >
        <div class="item3">
          123
        </div>
        <div class="item3">
          123
        </div>
        <div class="item3">
          123
        </div>
        <div class="item3">
          123
        </div>
      </div>


      <p>直接25%吧 焯</p>
      <div
        :style="{ width: `${width}%` }"
        class="box d-flex"
      >
        <div style="width: 25%;">
          item
        </div>
        <VSpacer />
        <div style="width: 25%;">
          item
        </div>
        <VSpacer />
        <div style="width: 25%;">
          item
        </div>
        <VSpacer />
        <div style="">
          item
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      satisfactionEmojis: ['😭', '😢', '☹️', '🙁', '😐', '🙂', '😊', '😁', '😄', '😍'],
      ticksLabels: ['😭', '😢', '☹️', '🙁', '😐', '🙂', '😊', '😁', '😄', '😍'],
      width: 100,
    }
  },
  mounted() {
    this.width = 50
  }
}
</script>

<style scoped>
.box {
  border: 1px solid;
  border-radius: 0.3rem;
}

.item1 {
  background-color: aquamarine;
  padding: 10px;
}

.box1 {
  display: flex;
  justify-content: space-between;
}

.box2 {
  height: 100px;
  background-color: beige;
}

.box2item1 {
  float: left;
  background-color: aquamarine;
  width: 50px;
  height: 100px;
}

.box22 {
  margin: 0 0 0 50px;
  background-color: goldenrod;
  height: 100%;
}

.box222 {
  float: right;
  width: 33.3%;
  background-color: tomato;
}
.box333 {
  float: right;
  background-color: tomato;
}
.itemmmm {
  float: right;
}

.box3 {
  text-align: justify;
  height: 60px;
}

.item3 {
  display: inline-block;
  background-color: aquamarine;
  height: 100%;
  width: 25%;
}

</style>